import { useScrollCtx } from "@/providers/AppProviders";
import { useMagnetic } from "@/hooks/useMagnetic";
import { MRLogo } from "./MRLogo";
import { content } from "@/lib/content";

export const Navbar = () => {
  const { scrollToProgress } = useScrollCtx();
  const ctaRef = useMagnetic(0.3);

  return (
    <header className="fixed inset-x-0 top-0 z-[60] pointer-events-none">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 sm:px-10">
        <button
          onClick={() => scrollToProgress(0.001)}
          data-cursor="hover"
          aria-label="MR Solutions — início"
          className="pointer-events-auto text-primary"
        >
          <MRLogo className="w-[43px] sm:w-[50px]" />
        </button>

        <nav className="pointer-events-auto hidden items-center gap-9 md:flex">
          {content.nav.map((n) => (
            <button
              key={n.label}
              onClick={() => scrollToProgress(n.p)}
              data-cursor="hover"
              className="relative text-sm font-medium text-foreground/70 transition-colors hover:text-foreground after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-primary after:transition-all after:duration-300 hover:after:w-full"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="pointer-events-auto">
          <button
            ref={ctaRef}
            onClick={() => scrollToProgress(0.93)}
            data-cursor="hover"
            className="rounded-full bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground shadow-soft transition-[background-color,transform] duration-200 hover:bg-primary/90"
          >
            {content.cta}
          </button>
        </div>
      </div>
    </header>
  );
};
